import { Injectable, Optional, SkipSelf } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class DialogService <T> {

    private showSource = new Subject<T>();
    onShowSource = this.showSource.asObservable();

    private updatedSource = new Subject<T>();
    onUpdate = this.updatedSource.asObservable();

    show(subject: T) {
        this.showSource.next(subject);
        return this;
    }

    update(subject: T) {
        this.updatedSource.next(subject);
        return this;
    }

}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/services/dialog.service.ts